export default __webpack_public_path__ + "static/media/logo-scriptreel.12159cb2.svg";